import _ from 'lodash';

// NOTE // formatting pax for the back-end sendText
export const formatPax = (paxArr) => {
  let paxArrCopy = _.cloneDeep(paxArr);

  for (let i = 0; i < paxArrCopy.length; i++) {
    let pax = paxArrCopy[i];
    pax.phoneNumber = pax.phone;
    pax.flightNumber = pax.FLTNO;
    pax.rloc = pax.PNRRefNo;
  }

  return paxArrCopy;
}

export const formatPaxName = (pax) => {
  let firstName = pax.FirstName[0] + pax.FirstName.slice(1).toLowerCase();
  let lastName = pax.LastName[0] + pax.LastName.slice(1).toLowerCase();
  return firstName + ' ' + lastName;
};

// NOTE // formatRecipients and getRecipients is a bit more complex than I wanted them to be, but the selected recipients weren't showing up in the SelectWithLabel otherwise
export const formatRecipients = (paxArr) => {
  let recipients = [{label: 'ALL', value: 'ALL'}];

  for (let i = 0; i < paxArr.length; i++) {
    const pax = paxArr[i];
    if (pax.FirstName && pax.LastName && pax.PNRRefNo && pax.phone) {
      // NOTE // label example: (TJJMG7) 3107731306 - Katherine Gottwald
      recipients.push({label: `(${pax.PNRRefNo}) ${pax.phone} - ${formatPaxName(pax)}`, value: `${pax.PNRRefNo}-${pax.phone}-${pax.FirstName}-${pax.LastName}`});
    }
  }

  return _.uniqBy(recipients, 'value');
};

export const getRecipients = (paxList, recipients) => {
  let output = []

  for (let i = 0; i < recipients.length; i++) {
    const recipient = recipients[i];
    let recipArr = recipient.split('-')
    let recipRLOC = recipArr[0]
    let recipPhone = recipArr[1]
    let recipFirstName = recipArr[2]
    let recipLastName = recipArr[3]
    let paxLoc = paxList.findIndex(pax => pax.PNRRefNo === recipRLOC && (pax.phone === recipPhone || pax.phoneNumber === recipPhone) && pax.FirstName === recipFirstName && pax.LastName === recipLastName)
    if (paxLoc !== -1) {
      output.push(paxList[paxLoc])
    }
  }

  return output
}